import { useEffect, useRef, useState } from "react";

/* Single-line text that glides slowly left when it overflows, pauses at the end, then resets. Hover pauses. */
export const Marquee = ({ children, speed = 24, delay = 1600, className = "", testid }) => {
  const box = useRef(null);
  const txt = useRef(null);
  const anim = useRef(null);
  const [over, setOver] = useState(0);
  useEffect(() => {
    const measure = () => setOver(Math.max(0, (txt.current?.scrollWidth || 0) - (box.current?.clientWidth || 0)));
    measure();
    const ro = new ResizeObserver(measure);
    if (box.current) ro.observe(box.current);
    if (txt.current) ro.observe(txt.current);
    return () => ro.disconnect();
  }, [children]);
  useEffect(() => {
    anim.current?.cancel();
    anim.current = null;
    if (!over || !txt.current) return;
    const wait = delay / 1000, travel = over / speed, hold = 2, reset = 0.6;
    const total = wait + travel + hold + reset;
    anim.current = txt.current.animate(
      [
        { transform: "translateX(0)", offset: 0 },
        { transform: "translateX(0)", offset: wait / total },
        { transform: `translateX(-${over}px)`, offset: (wait + travel) / total },
        { transform: `translateX(-${over}px)`, offset: (wait + travel + hold) / total, easing: "ease-in-out" },
        { transform: "translateX(0)", offset: 1 },
      ],
      { duration: total * 1000, iterations: Infinity },
    );
    return () => anim.current?.cancel();
  }, [over, speed, delay]);
  const mask = over ? "linear-gradient(90deg, transparent 0, #000 10px, #000 calc(100% - 14px), transparent 100%)" : undefined;
  return (
    <div ref={box} className={`relative min-w-0 overflow-hidden whitespace-nowrap ${className}`} data-testid={testid} data-scrolling={over ? "1" : "0"}
      onPointerEnter={() => anim.current?.pause()} onPointerLeave={() => anim.current?.play()}
      style={mask ? { WebkitMaskImage: mask, maskImage: mask } : undefined}>
      <span ref={txt} className="inline-block will-change-transform">{children}</span>
    </div>
  );
};
